/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;

  .fill {
    color: inherit;
  }
`
export default class LikeIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" css={Color}>
        <g id="그룹_8840" data-name="그룹 8840" transform="translate(-4381 -21972)">
          <rect id="사각형_7266" data-name="사각형 7266" width="30" height="30" transform="translate(4381 21972)" fill="#506070" opacity="0"/>
          <path id="합치기_269" className="fill" data-name="합치기 269"
                d="M12.545,15Q10.871,15,9.2,15q-1.546,0-3.09,0a1.508,1.508,0,0,1-1.641-1.645c0-2.385,0-4.77,0-7.154A1.688,1.688,0,0,1,5,4.9C6.555,3.382,8.08,1.837,9.615.3c.066-.067.118-.147.238-.3a9.411,9.411,0,0,1,.968,1.165,1.333,1.333,0,0,1,.09.86c-.189,1.016-.427,2.022-.646,3.032-.013.066-.018.134-.031.236h.311c1.41,0,2.822,0,4.232,0a1.5,1.5,0,0,1,1.585,1.181c.037.173-.038.367-.019.547a5.885,5.885,0,0,1-.652,3.162c-.581,1.246-1.085,2.526-1.616,3.8A1.523,1.523,0,0,1,12.551,15ZM2.813,15c-.93,0-1.859,0-2.812,0V6.071a1.666,1.666,0,0,1,.2-.023h.846c.563,0,1.128,0,1.692-.005.194,0,.245.059.245.248q-.008,4.228,0,8.458c0,.113.033.248-.159.248Z"
                transform="translate(4387.813 21978.5)" fill="#506070"/>
        </g>
      </svg>
    )
  }
}
